/**
 * Pozisyon CRUD servisi.
 * Firestore 'pozisyonlar' koleksiyonu üzerinde işlemler.
 */

import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  query,
  orderBy,
} from 'firebase/firestore'
import { getFirestoreDb } from '@/lib/firebase'
import { nowServer } from '@/lib/firestore'
import type { Pozisyon } from '@/types'

const POZISYONLAR = 'pozisyonlar'

function yeniId(): string {
  const db = getFirestoreDb()
  return doc(collection(db, POZISYONLAR)).id
}

export async function tumPozisyonlariGetir(): Promise<Pozisyon[]> {
  const db = getFirestoreDb()
  const q = query(collection(db, POZISYONLAR), orderBy('isim'))
  const snap = await getDocs(q)
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }) as Pozisyon)
}

export async function pozisyonGetir(id: string): Promise<Pozisyon | null> {
  const db = getFirestoreDb()
  const docSnap = await getDoc(doc(db, POZISYONLAR, id))
  if (!docSnap.exists()) return null
  return { id: docSnap.id, ...docSnap.data() } as Pozisyon
}

export async function pozisyonOlustur(
  data: { isim: string },
  olusturanId: string
): Promise<string> {
  const db = getFirestoreDb()
  const id = yeniId()

  await setDoc(doc(db, POZISYONLAR, id), {
    ...data,
    aktif: true,
    olusturanId,
    olusturmaTarihi: nowServer(),
  })

  return id
}

export async function pozisyonGuncelle(
  id: string,
  data: { isim?: string }
): Promise<void> {
  const db = getFirestoreDb()
  await updateDoc(doc(db, POZISYONLAR, id), data)
}

export async function pozisyonSil(id: string): Promise<void> {
  const db = getFirestoreDb()
  await updateDoc(doc(db, POZISYONLAR, id), { aktif: false })
}

export async function pozisyonGeriYukle(id: string): Promise<void> {
  const db = getFirestoreDb()
  await updateDoc(doc(db, POZISYONLAR, id), { aktif: true })
}
